(function () {
    'use strict';

    function thumbnailsDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/thumbnails';

        function loadThumbnails(objectId) {
            return $http.get(baseUrl + '/' + objectId.toLowerCase()).then(function (response) {
                return response.data;
            });
        };

        function loadThumbnailsForWorkflows(workflowIds) {
            return $http.post(baseUrl + '/workflows', { WorkflowIds: workflowIds }).then(function (response) {
                return response.data;
            });
        }

        function loadThumbnailsForObjectPaths(objectId, workflowPaths) {
            return $http.post(baseUrl + '/' + objectId.toLowerCase() + '/paths', { WorkflowPaths: workflowPaths }).then(function (response) {
                return response.data;
            });
        };

        function loadThumbnailsForWorkflowsAndPaths(workflowsAndPaths) {
            return $http.post(baseUrl + '/workflowsandpaths', { WorkflowsAndPaths: workflowsAndPaths }).then(function (response) {
                return response.data;
            });
        }

        return {
            loadThumbnails: loadThumbnails,
            loadThumbnailsForWorkflows: loadThumbnailsForWorkflows,
            loadThumbnailsForObjectPaths: loadThumbnailsForObjectPaths,
            loadThumbnailsForWorkflowsAndPaths: loadThumbnailsForWorkflowsAndPaths
        };
    }

    thumbnailsDataService.$inject = ['$http'];

    angular.module('ecap.common').service('thumbnailsDataService', thumbnailsDataService);
})();
